const isJson = ({ ContentType }: connect.ChatTranscriptItem) => ContentType === 'application/json';

// Filter out events and JSON messages from transcript
export default function filterChatTranscript(transcript?: connect.ChatTranscriptItem[]): connect.ChatTranscriptItem[] {
  if (!transcript) {
    return [];
  }

  return transcript.filter((transcript) => !isJson(transcript) || transcript.Type === 'ATTACHMENT');
}
